import React from "react";

const MyAvatar = ({
    initials,
    avatarClassName,
}) => {
   
    return (
        <span className={`flex ${avatarClassName} border-2 items-center justify-center overflow-hidden
                          rounded-full font-medium bg-gradient-to-br from-emerald-500 
                          to-purple-500 text-white size-full
                        `}>
            {initials}
        </span>
    );
};

export default MyAvatar;